import { useSelector } from 'react-redux';
import { getPretextPeriodForProduct } from 'reactApp/modules/products/products.helpers';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { IProduct } from 'reactApp/modules/products/products.types';
import { RootState } from 'reactApp/store';
import { getPeriodName, getPeriodNameAsWord, getTypeOfPeriodName } from 'reactApp/utils/Period';
import { formatPrice } from 'reactApp/utils/priceHelpers';

export const useProduct = ({ productId }) => {
    const product: IProduct = useSelector((state: RootState) => ProductsSelectors.getProductById(state, productId));

    const price = product?.discountPrice || product?.price || 0;
    const space = product?.space?.value || '';
    const trialPeriod = product?.trialPeriod || product?.discountPeriod;

    const formattedPrice = `${formatPrice(price)}\u00A0₽`;
    const fullPrice = `${formatPrice(product?.price)}\u00A0₽`;

    if (trialPeriod && price) {
        return `${getPretextPeriodForProduct(trialPeriod)} ${getPeriodNameAsWord(
            trialPeriod,
            true
        )} оплата составит ${fullPrice} в ${getTypeOfPeriodName(product.period)}.`;
    }

    return `Подписка на ${space} ${price && `за ${formattedPrice}`} продлевается автоматически через ${getPeriodName(
        product.period
    )} на аналогичный период.`;
};
